import {action, computed, observable} from 'mobx';
import {IStickyHandler} from './sticky-handler.interface';
import {DomEventSubscription} from '../../../utils/event-listener-registration';
import {IServiceFactory} from "../../services/service-factory.interface";

export class StickyHandler implements IStickyHandler {
  private _onScrollSubscription: DomEventSubscription;
  private _scrollTopMinValue: number = -1;

  constructor(private services: IServiceFactory) {
    this._updateHeaderHeight();
    this._onScrollSubscription = this.services.window.subscribeTo.scroll(this.onWindowScroll);
  }

  @observable private _isSticky: boolean = false;
  @computed get isSticky(): boolean {
    return this._isSticky;
  }

  @action
  private _setIsSticky(value: boolean): void {
    this._isSticky = value;
  }

  private onWindowScroll = () => {
      if(this._scrollTopMinValue < 0){
          this._setIsSticky(false);
      } else {
          this._setIsSticky(this.services.window.scrollY > this._scrollTopMinValue);
      }
  };

  dispose() {
    if(this._onScrollSubscription) {
        this._onScrollSubscription.dispose();
    }
  }

  async _updateHeaderHeight() {
      const headerRegulationDataElement = await this.services.header.getHeaderElement();
      this._scrollTopMinValue =  headerRegulationDataElement.getBoundingClientRect().top + headerRegulationDataElement.offsetHeight;
  }

}
